<div class="view-mode-toggle">
  <button
    class="vs-tertiary-btn current-mode-btn"
    [disabled]="viewMode === iconTypes.GRID"
    (click)="changeMode()"
  >
    <span class="material-icons">view_list</span>
  </button>
  <button
    class="vs-tertiary-btn current-mode-btn"
    [disabled]="viewMode === iconTypes.LIST"
    (click)="changeMode()"
  >
    <span class="material-icons">view_module</span>
  </button>
</div>


